import { Outlet } from 'react-router-dom'

import Independentlearning_k13_subjects from './independentlearning_k13_subjects';
import TopNavbar from '../../components/TopNavbar';


const Independentlearning_k13 = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
  <Independentlearning_k13_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Independentlearning_k13;